import { useQuery } from '@tanstack/react-query';

import { useFeatureFlags } from '@/modules/common/hooks/use-feature-flags';
import { getAvailableSettings } from '@/modules/settings/api/settings.api';

import { SettingType } from '../types/setting-type';

const AVAILABLE_SETTINGS_QUERY_KEY = ['available-settings'];

export function useAvailableSettings() {
  const { showTimeOffs } = useFeatureFlags();

  return useQuery({
    queryKey: AVAILABLE_SETTINGS_QUERY_KEY,
    queryFn: getAvailableSettings,
    staleTime: 5 * 60 * 1000,
    // Filtering lives in `select`, not `queryFn`, so it re-evaluates against the
    // latest `showTimeOffs` on every render. The backend feature flags they depend on
    // load asynchronously (BackendFeatureFlagsProvider), so `showTimeOffs` can still be
    // false at the moment this query first fetches; baking the filter into `queryFn`
    // freezes that stale value in the cache for the full 5-minute staleTime.
    select: settings => (showTimeOffs ? settings : settings.filter(s => s !== SettingType.TimeOff)),
  });
}
